import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CashierFlowType } from '../../../../types/Cashier';
import CTAButton from '../../../CTAButton/CTAButton';

import {
  TXTWCL_Back_to_Cashier,
  TXTWCL_Please_bear_with_usX_weXll_ema_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_13,
  TXTWCL_We_restricted_your_account_whi_ELL,
  TXTWCL_You_canXt_deposit_right_now,
  TXTWCL_You_canXt_withdraw_right_now
} from './SuspendRM.messages.json';

const SuspendRM: React.FC = () => {
  const {
    data: { cashierFlow }
  } = useWizardContext();
  return (
    <>
      {cashierFlow === CashierFlowType.FirstDeposit ? (
        <Translation tagName="h2" {...TXTWCL_You_canXt_deposit_right_now} />
      ) : (
        <Translation tagName="h2" {...TXTWCL_You_canXt_withdraw_right_now} />
      )}
      <p>
        <Translation tagName="span" {...TXTWCL_We_restricted_your_account_whi_ELL} />{' '}
        <Translation tagName="span" {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_13} />
      </p>
      <Translation tagName="p" {...TXTWCL_Please_bear_with_usX_weXll_ema_ELL} />
      <CTAButton type="button" alias="firstWalletHome" translation={TXTWCL_Back_to_Cashier} />
    </>
  );
};

export default SuspendRM;
